import React from "react"
import Typography from '@mui/material/Typography';


export const SourcesDiaT2 = () => {

return(
<div>

<Typography component="span" variant="h5" sx={{fontWeight: '700'}}>Sources: </Typography>
<br /> <br />
https://www.ncbi.nlm.nih.gov/books/NBK1662/  <br />
https://www.ncbi.nlm.nih.gov/gtr/conditions/C0011854/ <br />
https://www.cdc.gov/diabetes/basics/what-is-type-1-diabetes.html#:~:text=People%20of%20all%20ages%20can,builds%20up%20in%20the%20bloodstream. <br />
https://www.ncbi.nlm.nih.gov/gtr/all/tests/?term=Diabetes   <br /> 

</div>
)
}